module.exports = __webpack_public_path__ + "media/clipboard.2b4cb3c2.svg";